import { useContextState } from "../../../../../../hooks/theme"

function useStyles() {
    const { colors } = useContextState()
    return {
        tabList: {
            width: '100%',
            '& .MuiTabs-flexContainer': {
                paddingTop: '5px',
            },
            '& .MuiTab-root': {
                borderTopLeftRadius: '0px',
                borderTopRightRadius: '0px',
                backgroundColor: `transparent`,
                color: colors.color10,
                '& .MuiTabs-scroller': {
                    overflow: 'auto',
                },
                '&.Mui-selected': {
                    backgroundColor: `transparent`,
                    color: colors.primary,
                },
            },
            '& .MuiTabs-indicator': {
                backgroundColor: colors.primary,
                height: '3px'
            },
        },

    }
}

export { useStyles }